module.exports = __webpack_public_path__ + "static/media/noun-suitcase-1560743-142350.170877e1.svg";